import React, { useState, useEffect, useRef } from "react";
import { FaTachometerAlt, FaSignOutAlt, FaBars, FaTimes, FaBuilding } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { BsPersonBadge } from 'react-icons/bs';
import { AiOutlineBranches } from 'react-icons/ai';
import { BsFillPersonCheckFill } from 'react-icons/bs';
import { RiArrowDropDownLine, RiBillLine, RiChatFollowUpLine, RiCustomerServiceLine } from 'react-icons/ri';
import { MdOutlineInventory, MdOutlineSupportAgent } from 'react-icons/md';
import { MdAccountBalance, MdAssignmentReturn } from 'react-icons/md';
import { FaShoppingCart, FaFileAlt, FaSearch } from "react-icons/fa";
import { FaCartFlatbedSuitcase } from 'react-icons/fa6';
import { AiOutlineUserAdd } from 'react-icons/ai';
import { BiPurchaseTagAlt, BiSolidReport } from 'react-icons/bi';
import { MdOutlinePayments } from "react-icons/md";
import { MdOutlineFreeCancellation } from "react-icons/md";
import { MdEventNote } from 'react-icons/md';
import { FaSortAmountUp } from "react-icons/fa";
import { IoIosCreate } from "react-icons/io";
import { MdOutlineInventory2 } from "react-icons/md";
import { MdOutlineAccountBalance } from "react-icons/md";
import { SlCalender } from "react-icons/sl";
import { GiConfirmed } from "react-icons/gi";
import { BsFillPersonVcardFill } from "react-icons/bs";
import { FaMapMarkerAlt } from "react-icons/fa";
import { MdPersonAddAlt1 } from "react-icons/md";

import { PiBank } from "react-icons/pi";
import { AiOutlineIssuesClose } from "react-icons/ai";
import { CgShutterstock } from "react-icons/cg";
import { VscGitPullRequestGoToChanges } from "react-icons/vsc";
import { IoReceiptOutline } from "react-icons/io5";
import { TbReport } from "react-icons/tb";
import { FaBoxTissue } from "react-icons/fa6";
import { RiMoneyRupeeCircleLine } from "react-icons/ri";
import { FaClipboardList } from "react-icons/fa";
import { GrUserManager } from "react-icons/gr";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { IoDocumentOutline } from "react-icons/io5"
import { MdAddIcCall } from "react-icons/md";

import { TbReportSearch } from "react-icons/tb";
import { FaClipboardUser } from "react-icons/fa6";
import { MdFollowTheSigns } from "react-icons/md";
import { IoSearch } from "react-icons/io5";
import { IoCall } from "react-icons/io5";

import { TfiHeadphoneAlt } from "react-icons/tfi";
import { RiCustomerServiceFill } from "react-icons/ri";
import { FaMoneyBill } from "react-icons/fa";

import "../css/admin/AdminSidebar.css";
import logo from '../assets/logo.png';
import { HiOutlineReceiptTax } from "react-icons/hi";
import { FaUserLock } from "react-icons/fa";
import { IoTimerOutline } from "react-icons/io5";
import { CiViewTimeline } from "react-icons/ci";
import { SiStatuspage } from "react-icons/si";
import { MdOutlineProductionQuantityLimits } from "react-icons/md";
import { SiMaterialdesignicons } from "react-icons/si";
import { TbBrandProducthunt } from "react-icons/tb";
import { BiDetail } from "react-icons/bi";
import { GrSchedulePlay } from "react-icons/gr";
import { RiRedPacketFill } from "react-icons/ri";
import { HiTemplate } from "react-icons/hi";
import { HiOutlinePhoneMissedCall } from "react-icons/hi"
import { PiMapPinAreaDuotone } from "react-icons/pi";
import { GoChecklist } from "react-icons/go";
import { FaDatabase } from "react-icons/fa";
import { PiPhoneCallBold } from "react-icons/pi";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import { RiAdminLine } from "react-icons/ri";
import { LuHeadset } from "react-icons/lu";
import { MdOutlinePageview } from "react-icons/md";
import { BsCashStack } from "react-icons/bs";
import { RiBankFill } from "react-icons/ri";
import { FaRegCreditCard } from "react-icons/fa";
import { IoCardSharp } from "react-icons/io5";
import { FcSimCardChip } from "react-icons/fc";
import { GiExpense } from "react-icons/gi";
import { RiContractFill } from "react-icons/ri";
import { FaCentercode } from "react-icons/fa";
import { HiMiniBuildingOffice2 } from "react-icons/hi2";
import { GrLink } from "react-icons/gr";
import { BsPostcard } from "react-icons/bs";
import { MdOpenInNew, MdOutlinePostAdd } from "react-icons/md";
import { FaUserCheck } from "react-icons/fa";
import { FaRegImage } from "react-icons/fa";
import { MdOutlineCardGiftcard } from "react-icons/md";
import axios from 'axios'
import { io } from "socket.io-client";
import { RiMessage2Line } from "react-icons/ri";
import { LuMessageSquareText } from "react-icons/lu";
import { TbMessage2Star } from "react-icons/tb";
import { MdInsertPageBreak } from "react-icons/md";
import { BsPersonBoundingBox } from "react-icons/bs";
import { GoPerson } from "react-icons/go";
import { FaMoneyCheckDollar } from "react-icons/fa6";
import { TiShoppingCart } from "react-icons/ti";
import { TbReportAnalytics } from "react-icons/tb";
import { TbReportMoney } from "react-icons/tb";
import { TbReportMedical } from "react-icons/tb";
import { MdAvTimer } from "react-icons/md";
import { GiBlackBook } from "react-icons/gi";
import { IoCalendarNumber } from "react-icons/io5";
import { FiBell } from "react-icons/fi";
import { FaStarHalfStroke } from "react-icons/fa6";
import { DiGitBranch } from "react-icons/di";
import { PiChalkboardTeacherFill } from "react-icons/pi";
import { MdOutlineSettingsSuggest } from "react-icons/md";
import { RiPagesFill } from "react-icons/ri";
import { HiDocumentCurrencyRupee } from "react-icons/hi2";
import { IoBarcode } from "react-icons/io5";
import { LiaSitemapSolid } from "react-icons/lia";


    import socket from "../socket";
import { useStateManager } from "react-select";

const AdminSidebar = ({ adminData, role }) => {
  const [activeLink, setActiveLink] = useState('');
  // const [role, setRole] = useState('');
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("")
  const [permissions, setPermissions] = useState({});
  const [branchID, setBranchID] = useState(() => localStorage.getItem('branchID') || '');
  const [permissionContext, setPermissionContext] = useState('');
  const [identityBranchID, setIdentityBranchID] = useState(() => localStorage.getItem('branchID') || '');
  const [identityBranches, setIdentityBranches] = useState([]);
  const [unreadNotifications, setUnreadNotifications] = useState({});
  const [materialIssueUnread, setMaterialIssueUnread] = useState(0);
  const [materialUnread, setMaterialUnread] = useState(0);
    const[complaintUnread,setComplaintUnread] = useState(0);
        const[amctUnread,setAmcUnread] = useState(0);

    const [noticeUnread, setNoticeUnread] = useState(0);
const [applicationUnread, setApplicationUnread] = useState(0);
const[materialRequest,setMaterialRequest] = useState(0);
const[materialIssue,setMaterialIssue] = useState(0);
const[materialReceipt,setMaterialReceipt] = useState(0);
const[pms,setPms] = useState(0);
const[leave,setLeave] = useState(0);

  useEffect(() => {
    const syncIdentityBranch = () => setIdentityBranchID(localStorage.getItem('branchID') || '');
    syncIdentityBranch();
    window.addEventListener('storage', syncIdentityBranch);
    window.addEventListener('focus', syncIdentityBranch);
    const interval = setInterval(syncIdentityBranch, 1000);
    return () => {
      clearInterval(interval);
      window.removeEventListener('storage', syncIdentityBranch);
      window.removeEventListener('focus', syncIdentityBranch);
    };
  }, []);

  useEffect(() => {
    let live = true;
    axios.get('https://api.skyguard.group/api/fetch-branch')
      .then(response => {
        if (live) setIdentityBranches(Array.isArray(response.data.result) ? response.data.result : []);
      })
      .catch(error => console.error('Failed to load current branch name:', error));
    return () => { live = false; };
  }, []);

  const identityUser = adminData?.user || {};
  const employeeName = [identityUser.first, identityUser.middle, identityUser.last]
    .filter(part => typeof part === 'string' && part.trim()).map(part => part.trim()).join(' ');
  const identityBranch = identityBranches.find(branch => String(branch.id) === identityBranchID);
  const sessionAssignments = adminData?.branch_roles || identityUser.branch_roles || [];
  const branchAssignment = Array.isArray(sessionAssignments) ? sessionAssignments.find(assignment =>
    String(assignment.branch_id) === identityBranchID && assignment.status === 'ACTIVE') : null;
  const assignedBranchRole = branchAssignment?.role_name || '';

useEffect(() => {
  socket.on("connect", () => {
    console.log("Socket connected:", socket.id);
  });

  socket.on("new-notice", (data) => {
    setNoticeUnread(prev => prev + 1);
  });

   socket.on("new-application", (data) => {
    setApplicationUnread(prev => prev + 1);
  });

    socket.on("new-call", (data) => {
    setComplaintUnread(prev => prev + 1);
  });

    socket.on("new-amc", (data) => {
    setAmcUnread(prev => prev + 1);
  });

   socket.on("material-request", (data) => {
    setMaterialRequest(prev => prev + 1);
  });


   socket.on("material_issue", (data) => {
    setMaterialIssue(prev => prev + 1);
  });

   socket.on("material-receipt", (data) => {
    setMaterialReceipt(prev => prev + 1);
  });

  
   socket.on("new-pms-call", (data) => {
    setPms(prev => prev + 1);
  });

   socket.on("leave-apply", (data) => {
    setLeave(prev => prev + 1);
  });


  return () => {
    socket.off("new-notice");
     socket.off("new-application");
     socket.off("new-amc");
       socket.off("new-call");
       socket.off('material-request')
       socket.off('material_issue');
       socket.off('leave-apply');
       socket.off('new-pms-call')
  };
}, [])

 

  const [expandedSections, setExpandedSections] = useState(
    SIDEBAR_CONFIG.reduce((acc, item) => {
      acc[item.key] = false;
      return acc;
    }, {})
  );




  const sidebarRef = useRef(null);

  useEffect(() => {
    const storedRole = localStorage.getItem('role');

    setActiveLink(window.location.pathname);
  }, []);



  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      localStorage.removeItem("role");
      localStorage.removeItem("permissions");
      navigate("/admin-login");
    }
  };


  const toggleSection = (section) => {
    setExpandedSections(prev => {
      const newState = {};
      Object.keys(prev).forEach(key => {
        newState[key] = key === section ? !prev[key] : false;
      });
      return newState;
    });
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);



  const userID = adminData.user.id;

  useEffect(() => {
    if (role === 'admin') return;
    const syncBranch = () => {
      const current = localStorage.getItem('branchID') || '';
      if (branchID !== current) {
        setPermissions({});
        setPermissionContext('');
        localStorage.removeItem('permissions');
        setBranchID(current);
      }
    };
    syncBranch();
    window.addEventListener('storage', syncBranch);
    window.addEventListener('focus', syncBranch);
    // Same-window localStorage writes do not emit a storage event.
    const interval = setInterval(syncBranch, 1000);
    return () => {
      clearInterval(interval);
      window.removeEventListener('storage', syncBranch);
      window.removeEventListener('focus', syncBranch);
    };
  }, [role, branchID]);

  useEffect(() => {
    if (role === 'admin') return;
    setPermissions({});
    setPermissionContext('');
    localStorage.removeItem('permissions');
    if (!userID || !branchID) return;
    let live = true;
    let request = 0;
    const context = String(userID) + ':' + branchID;
    const fetchPermissions = async () => {
      const version = ++request;
      try {
        const response = await axios.get('https://api.skyguard.group/api/user-permissions/' + userID,
          { params: { branch_id: branchID, employee_key: 'id' } });
        if (!live || version !== request || localStorage.getItem('branchID') !== branchID) return;
        const resolved = response.data.permissions;
        if (!resolved || typeof resolved !== 'object' || Array.isArray(resolved)) throw new Error('Invalid permission response');
        setPermissions(resolved);
        setPermissionContext(context);
      } catch (error) {
        if (!live || version !== request) return;
        setPermissions({});
        setPermissionContext('');
        localStorage.removeItem('permissions');
        console.error('Failed to fetch branch permissions:', error);
      }
    };
    fetchPermissions();
    const interval = setInterval(fetchPermissions, 10000);
    return () => { live = false; clearInterval(interval); };
  }, [userID, branchID, role]);

  let parsedPermissions = {};

  try {
    if (typeof permissions === "string") {
      parsedPermissions = permissions.trim().startsWith("{")
        ? JSON.parse(permissions)
        : {}; // "ALL", "ADMIN", etc.
    } else {
      parsedPermissions = permissions || {};
    }
  } catch (err) {
    console.error("Invalid permissions JSON:", permissions);
    parsedPermissions = {};
  }



  if (role !== 'admin' && (permissionContext !== String(userID) + ':' + branchID ||
      branchID !== (localStorage.getItem('branchID') || ''))) parsedPermissions = {};

  const normalizedPermissions = { ...parsedPermissions };


  if (parsedPermissions?.report) {
    const report = parsedPermissions.report;

    const mapReport = (moduleKey, path) => {
      if (report[path]?.access || report[path]?.allowed) {
        normalizedPermissions[moduleKey] =
          normalizedPermissions[moduleKey] || {};
        normalizedPermissions[moduleKey][path] = {
          allowed: true,
          ...report[path],
        };
      }
    };

    mapReport("inventory", "/admin/inventory-report");
    mapReport("attendence", "/admin/attendence-report");
    mapReport("payroll", "/admin/payroll-report");
  }




  const isMenuAllowed = (permissions, moduleKey, path) => {
    const modulePerm = permissions?.[moduleKey];
    if (!modulePerm || Array.isArray(modulePerm)) return false;

    return modulePerm?.[path]?.allowed === true;
  };

  return (
    <>
      {/* Mobile Navbar */}
      <div className="mobile-navbar d-md-none d-flex justify-content-between align-items-center p-2 text-black fixed-top w-100 shadow-sm">
        <span className="fw-bold fs-6 text-truncate me-2">Hello, {role?.toUpperCase()} !</span>
        <div className="d-flex align-items-center gap-2 flex-shrink-0">
          <button
            onClick={handleLogout}
            className="btn btn-outline-danger btn-sm d-flex align-items-center px-2 py-1 fw-semibold"
            title="Logout"
            aria-label="Logout"
          >
            <FaSignOutAlt className="me-1" />
            <span>Logout</span>
          </button>
          <button
            className="btn btn-light btn-sm"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle navigation"
          >
            {isOpen ? <FaTimes size={18} /> : <FaBars color="black" size={18} />}
          </button>
        </div>
      </div>

      {/* Sidebar */}
      <div ref={sidebarRef} className={`sidebar d-md-flex ${isOpen ? "open" : ""}`}>
        <div className="sidebar-header">
          <div className="d-flex justify-content-between align-items-center mt-2">
            <div className="d-flex align-items-center">
              <img src={logo} alt="logo" style={{ height: "40px" }} />
              <p className='fs-4 text-black fw-bold mb-0 ms-1'>SKY<span className='text-info'>GUARD</span></p>
            </div>
            <button
              type="button"
              className="btn btn-light btn-sm d-md-none p-1 text-secondary"
              onClick={() => setIsOpen(false)}
              aria-label="Close sidebar"
            >
              <FaTimes size={18} />
            </button>
          </div>
          <section aria-label="Logged-in user" className="border rounded bg-light text-start p-2 mt-2 small fw-normal"
            style={{ lineHeight: 1.4, overflowWrap: 'anywhere' }}>
            <div className="fw-semibold">{role === 'admin' ? 'Super Admin' : employeeName || 'Staff'}</div>
            <div><span className="text-secondary">Employee ID: </span>{identityUser.emp_id || 'Unavailable'}</div>
            <div><span className="text-secondary">Branch: </span>
              {identityBranch?.name || (identityBranchID ? `ID ${identityBranchID}` : 'Not selected')}
            </div>
            {role !== 'admin' && assignedBranchRole && <div>
              <span className="text-secondary">Role: </span>{assignedBranchRole}
            </div>}
          </section>
          <hr />
        </div>

        <ul className="sidebar-menu list-unstyled">


          {SIDEBAR_CONFIG.map(module => {
            const moduleKey = module.key;

            let allowedMenus = [];

            if (role === "admin") {
              allowedMenus = module.menus;
            } else {
              allowedMenus = module.menus.filter(menu =>
                isMenuAllowed(normalizedPermissions, moduleKey, menu.path)
              );
            }

            if (allowedMenus.length === 0) return null;

            const Icon = module.icon;
            const isExpanded = expandedSections[moduleKey] ?? true;

            return (
              <React.Fragment key={moduleKey}>
                <li
                  className={`section-title p-2 rounded border d-flex align-items-center mt-1 btn
         ${isExpanded ? "bg-primary text-white" : "bg-light text-dark"
                    }`}
                  onClick={() => toggleSection(moduleKey)}
                >
                  <span className="fw-bold ">
                    <Icon size={17} /> {module.label}
                  </span>
                </li>

                {isExpanded && (
                  <ul className="section-list">
               

                    {allowedMenus.map(menu => {
                      const MenuIcon = menu.icon || Icon;

                      // Check if this is "Material issue"
                      const isMaterialIssue = menu.path === "/admin/materail-issue";
                       const isNotice = menu.path === "/admin/notice-board";
                       const isApplication = menu.path === "/admin/applications";
                        const isComplaint = menu.path === "/admin/crm/complaint";
                           const isAmc = menu.path === "/admin/amc";
                    const isMatRequest = menu.path === "/admin/po-requistion";
                     const isMatissue = menu.path === "/admin/materail-issue";
                      const isMatReceipt = menu.path === "/admin/material-receipt";
                         const isPms = menu.path === "/admin/generate-pms";
                              const isLeave = menu.path === "/admin/leave-request";
                      return (
                        <li
                          key={menu.path}
                          onClick={() => {
                            setActiveLink(menu.path);
                            setIsOpen(false);
                            if (isMaterialIssue) setMaterialUnread(0); 
                            if(isNotice) setNoticeUnread(0);
                            if (isApplication) setApplicationUnread(0);
                            if(isComplaint) setComplaintUnread(0);
                            if(isAmc) setAmcUnread(0);
                            if(isMatRequest) setMaterialRequest(0);
                            if(isMatissue)setMaterialIssue(0);
                            if(isMatReceipt) setMaterialReceipt(0);
                              if(isPms) setPms(0);
                              if(isLeave) setLeave(0);
                          }}
                          className="p-1 rounded"
                        >
                          <Link
                            to={menu.path}
                            className={`d-flex align-items-center gap-2 text-decoration-none ${activeLink === menu.path ? "bg-success text-white" : "text-dark"
                              }`}
                            style={{ position: "relative" }}
                          >
                            <MenuIcon size={15} /> {menu.label}

                            {/* Red dot for material issue */}
                            {isMaterialIssue && materialUnread > 0 && (
                              <span
                                style={{
                                  position: "absolute",
                                  top: "6px",
                                  right: "10px",
                                  width: "8px",
                                  height: "8px",
                                  backgroundColor: "red",
                                  borderRadius: "50%",
                                }}
                              />
                            )}

                             {isNotice && noticeUnread > 0 && (
                              <span
                                style={{
                                  position: "absolute",
                                  top: "6px",
                                  right: "10px",
                                  width: "8px",
                                  height: "8px",
                                  backgroundColor: "red",
                                  borderRadius: "50%",
                                }}
                              />
                            )}

 {isApplication && (
  <div style={{ position: "relative", display: "flex", alignItems: "center" }}>

    <FiBell size={16} />

    {applicationUnread > 0 && (
  <span
    style={{
      position: "absolute",
      top: "-6px",
      right: "-6px",
      backgroundColor: "red",
      color: "white",
      fontSize: "10px",
      borderRadius: "50%",
      padding: "2px 5px",
      minWidth: "16px",
      textAlign: "center",
    }}
  >
    {applicationUnread}
  </span>
)}

  </div>
)}

 {isComplaint && (
  <div style={{ position: "relative", display: "flex", alignItems: "center" }}>



    {complaintUnread > 0 && (
  <span
    style={{
      position: "absolute",
      top: "-6px",
      right: "-6px",
      backgroundColor: "red",
      color: "white",
      fontSize: "10px",
      borderRadius: "50%",
      padding: "2px 5px",
      minWidth: "16px",
      textAlign: "center",
    }}
  >
    {complaintUnread}
  </span>
)}

  {amctUnread > 0 && (
  <span
    style={{
      position: "absolute",
      top: "-6px",
      right: "-6px",
      backgroundColor: "red",
      color: "white",
      fontSize: "10px",
      borderRadius: "50%",
      padding: "2px 5px",
      minWidth: "16px",
      textAlign: "center",
    }}
  >
    {amctUnread}
  </span>
)}

  </div>
)}


{isMatRequest &&(
    <div style={{ position: "relative", display: "flex", alignItems: "center" }}>

  

    {materialRequest > 0 && (
  <span
    style={{
      position: "absolute",
      top: "-6px",
      right: "-6px",
      backgroundColor: "red",
      color: "white",
      fontSize: "10px",
      borderRadius: "50%",
      padding: "2px 5px",
      minWidth: "16px",
      textAlign: "center",
    }}
  >
    {materialRequest}
  </span>
)}

  </div>
) }

{isMatissue &&(
    <div style={{ position: "relative", display: "flex", alignItems: "center" }}>

 

    {materialIssue > 0 && (
  <span
    style={{
      position: "absolute",
      top: "-6px",
      right: "-6px",
      backgroundColor: "red",
      color: "white",
      fontSize: "10px",
      borderRadius: "50%",
      padding: "2px 5px",
      minWidth: "16px",
      textAlign: "center",
    }}
  >
    {materialIssue}
  </span>
)}

  </div>
) }

{isMatReceipt &&(
    <div style={{ position: "relative", display: "flex", alignItems: "center" }}>

   

    {materialReceipt > 0 && (
  <span
    style={{
      position: "absolute",
      top: "-6px",
      right: "-6px",
      backgroundColor: "red",
      color: "white",
      fontSize: "10px",
      borderRadius: "50%",
      padding: "2px 5px",
      minWidth: "16px",
      textAlign: "center",
    }}
  >
    {materialReceipt}
  </span>
)}

  </div>
) }

{isPms &&(
    <div style={{ position: "relative", display: "flex", alignItems: "center" }}>

   

    {pms > 0 && (
  <span
    style={{
      position: "absolute",
      top: "-6px",
      right: "-6px",
      backgroundColor: "red",
      color: "white",
      fontSize: "10px",
      borderRadius: "50%",
      padding: "2px 5px",
      minWidth: "16px",
      textAlign: "center",
    }}
  >
    {pms}
  </span>
)}

  </div>
) }


{isLeave &&(
    <div style={{ position: "relative", display: "flex", alignItems: "center" }}>

   

    {leave > 0 && (
  <span
    style={{
      position: "absolute",
      top: "-6px",
      right: "-6px",
      backgroundColor: "red",
      color: "white",
      fontSize: "10px",
      borderRadius: "50%",
      padding: "2px 5px",
      minWidth: "16px",
      textAlign: "center",
    }}
  >
    {leave}
  </span>
)}

  </div>
) }
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </React.Fragment>
            );
          })}

        </ul>

        <ul className="sidebar-footer list-unstyled mb-0">
          <li
            onClick={handleLogout}
            className="logout-btn text-danger d-flex align-items-center"
            style={{ cursor: "pointer" }}
          >
            <FaSignOutAlt className="icon me-2" />
            Logout
          </li>

        </ul>


      </div>

      {/* Overlay for mobile */}
      {isOpen && <div className="sidebar-overlay d-md-none" onClick={() => setIsOpen(false)}></div>}
    </>
  );
};

export default AdminSidebar;



export const SIDEBAR_CONFIG = [

  {
    key: "admin",
    label: "Admin",
    icon: BsPersonBadge,
    menus: [
      { label: "Dashboard", path: "/admin/dashboard", icon: FaTachometerAlt },
      { label: "Companies", path: "/admin/companies", icon: FaBuilding },
      { label: "Branches", path: "/admin/branches", icon: AiOutlineBranches },
    ],
  },

  {
    key: "master",
    label: "Master",
    icon: BsFillPersonCheckFill,
    menus: [
      { label: "Role Type", path: "/admin/role", icon: BsFillPersonVcardFill },
      { label: "State Type", path: "/admin/state", icon: FaMapMarkerAlt },
      { label: "Party Type", path: "/admin/party-master", icon: MdPersonAddAlt1 },
      { label: "Account Type", path: "/admin/account-master", icon: PiBank },
      { label: "Complaint Type", path: "/admin/complaint-type-master", icon: AiOutlineIssuesClose },
      { label: "Charge Type", path: "/admin/charge-type", icon: HiOutlineReceiptTax },
      { label: "Coupan", path: "/admin/add-coupon", icon: MdOutlineCardGiftcard },
      { label: "Schedule", path: "/admin/schedule", icon: MdAvTimer },
        { label: "Financial Year", path: "/admin/financial-year-list", icon: IoCalendarNumber },
            { label: "HSN Master", path: "/admin/hsn-master", icon: IoBarcode },
            { label: "Group Master", path: "/admin/group-master", icon: LiaSitemapSolid },
       { label: "Setting", path: "/admin/setting", icon: MdOutlineSettingsSuggest },   
    ],
  },

  {
    key: "inventory",
    label: "Inventory",
    icon: MdOutlineInventory2,
    menus: [
      { label: "Add Inventory", path: "/admin/inventory", icon: MdOutlineInventory },
      { label: "Material Requistion", path: "/admin/po-requistion", icon: VscGitPullRequestGoToChanges },
      { label: "Material issue", path: "/admin/materail-issue", icon: AiOutlineIssuesClose },
      { label: "Material Return", path: "/admin/material-receipt", icon: IoReceiptOutline },
      { label: "Stock Transfer", path: "/admin/stock-transfer" },
      { label: "Report", path: "/admin/inventory-report", icon: TbReport },
      { label: "Godown", path: "/admin/godown", icon: FaBoxTissue },
      { label: "Sale Order", path: "/admin/manage-order", icon: TiShoppingCart },
      { label: " Document", path: "/admin/inventory-document", icon: GiBlackBook },
      
    ],
  },
  {
    key: "account",
    label: "Account",
    icon: MdAccountBalance,
    menus: [
      { label: "Party", path: "/admin/party", icon: MdOutlineInventory },
      { label: "Account", path: "/admin/accounts", icon: MdAccountBalance },
      { label: "Bank Payment", path: "/admin/bank-payment", icon: RiBankFill },
      { label: "Cash Payment", path: "/admin/cash-payment", icon: BsCashStack },
      { label: "Bank Receipt", path: "/admin/bank-receipt", icon: RiBankFill },
      { label: "Cash Receipt", path: "/admin/cash-receipt", icon: BsCashStack },
      { label: "Credit Note", path: "/admin/credit-note", icon: FaRegCreditCard },
      { label: "Debit Note", path: "/admin/debit-note", icon: IoCardSharp },
      { label: "Journal Voucher", path: "/admin/journal-voucher", icon: FcSimCardChip },
      { label: "Expense Voucher", path: "/admin/expnse-voucher", icon: GiExpense },
      { label: "Contra Voucher", path: "/admin/contra-voucher", icon: RiContractFill },
      { label: "Account Report", path: "/admin/account-report", icon: TbReport },
        { label: " Document", path: "/admin/account-document", icon: GiBlackBook },
            { label: "Bank Re-concilation", path: "/admin/bank-reconcilation", icon: GiBlackBook },
    ],
  },

  {
    key: "hrms",
    label: "HRMS",
    icon: GrUserManager,
    menus: [
      { label: "Add Employee", path: "/admin/add-employee", icon: AiOutlineUserAdd },
      { label: "Add Holiday", path: "/admin/add-holiday", icon: SlCalender },
      { label: "Leave Request", path: "/admin/leave-request", icon: GiConfirmed },
      //    { label: "User Rights", path: "/admin/user-right" },
      { label: "Loan", path: "/admin/loan", icon: RiMoneyRupeeCircleLine },
      { label: "Notice Board", path: "/admin/notice-board", icon: FaClipboardList },
      { label: "Documents", path: "/admin/hrms-document", icon: IoDocumentOutline },
      { label: "Report", path: "/admin/hrms-report", icon: TbReport },
    ],
  },
  {
    key: "attendence",
    label: "Time Attendance ",
    icon: BsFillPersonCheckFill,
    menus: [
      { label: "Leave Master", path: "/admin/leave-master", icon: MdOutlineFreeCancellation },
      { label: "Leave", path: "/admin/leave-application", icon: MdEventNote },
      { label: "Daily Attendance", path: "/admin/emp-attendence", icon: BsFillPersonCheckFill },
      { label: "Report", path: "/admin/attendence-report", icon: BiSolidReport },
    ],
  },
  {
    key: "payroll",
    label: "Payroll ",
    icon: MdOutlinePayments,
    menus: [
      { label: "Pay Head ", path: "/admin/pay-head", icon: MdOutlinePayments },
      { label: "PayHead Amt.", path: "/admin/monthwise-payhead-amounts", icon: FaSortAmountUp },
      { label: " Generate Payroll", path: "/admin/generate-payroll", icon: IoIosCreate },
      { label: "Payroll Report", path: "/admin/payroll-report", icon: TbReport },
      { label: "Payhead Report", path: "/admin/payhead-report", icon: TbReport },
    ],
  },

  {
    key: "recruitment",
    label: "Recruitment",
    icon: BsPostcard,
    menus: [
      { label: "Post Openings ", path: "/admin/post-openings", icon: MdOpenInNew },
      { label: "Applications", path: "/admin/my-applications", icon: MdOutlinePostAdd },
    ],
  },
  {
    key: "purchase",
    label: "Purchase",
    icon: BiPurchaseTagAlt,
    menus: [
      { label: "Purchase Enquiry", path: "/admin/purchase-enquiry", icon: FaSearch },
      { label: "Purchase Quotation", path: "/admin/quotation", icon: FaFileAlt },
      { label: "Purchase Order", path: "/admin/order", icon: FaCartFlatbedSuitcase },
      { label: "Purchase Bill", path: "/admin/purchase", icon: FaShoppingCart },
      { label: "Purchase Return", path: "/admin/purchase-return", icon: MdAssignmentReturn },
      { label: " Document", path: "/admin/purchase-document", icon: GiBlackBook },
    ],
  },
  {
    key: "sales",
    label: "Sales",
    icon: RiBillLine,
    menus: [
      { label: "Sale Quotation", path: "/admin/sale-quotation", icon: HiOutlineDocumentReport },
      { label: "Performa Invoice", path: "/admin/performa-invoice", icon: MdOutlineSupportAgent },
      { label: "Sale Invoice", path: "/admin/sale-invoice", icon: HiOutlineDocumentReport },
      { label: "Delivery Challan", path: "/admin/delivery-challan", icon: HiOutlineDocumentReport },
      { label: "Sale Return", path: "/admin/sale-return", icon: HiOutlineDocumentReport },
      { label: "Report", path: "/admin/sale-report", icon: TbReport },
      { label: "Documents", path: "/admin/sale-document", icon: GiBlackBook },
    ],
  },
  {
    key: "services",
    label: "Services",
    icon: RiCustomerServiceFill,
    menus: [
      { label: "Call", path: "/admin/crm/complaint", icon: IoCall },
      { label: "Recharge", path: "/admin/crm/recharge", icon: FaMoneyBill },
      { label: "Vendor Calls", path: "/admin/crm/vendor-call", icon: TfiHeadphoneAlt },
      { label: "Service Schedule ", path: "/admin/generate-pms", icon: GrSchedulePlay },
      { label: "Service Report ", path: "/admin/service-report-pms", icon: TbReportSearch },
      { label: "Repair Quoattaion ", path: "/admin/repair-quoattaion", icon: MdOutlinePageview },
      { label: "Repair Invoice ", path: "/admin/repair-invoice", icon: HiOutlineDocumentReport },
      { label: " Document", path: "/admin/service-document", icon: GiBlackBook },
    ],
  },
  {
    key: "CRM",
    label: "CRM",
    icon: FaClipboardUser,
    menus: [
      { label: "FollowUp Status", path: "/admin/crm/followup-status", icon: SiStatuspage },
      { label: "FollowUp", path: "/admin/crm/followup", icon: MdFollowTheSigns },
      { label: "Sales Enquiry", path: "/admin/crm/sales-enquiry", icon: IoSearch },
      { label: "Add Data", path: "/admin/crm-bulk-data", icon: FaDatabase },
      { label: "CRM Report", path: "/admin/crm-report", icon: FaDatabase },
      { label: " Document", path: "/admin/crm-document", icon: GiBlackBook },
    ],
  },
  {
    key: "franchisee-admin",
    label: "Franchisee Admin",
    icon: FaClipboardUser,
    menus: [
      { label: "Denied Call", path: "/admin/denied-call", icon: HiOutlinePhoneMissedCall },
      { label: "Franchisee Area ", path: "/admin/franchisee-area", icon: PiMapPinAreaDuotone },


    ],
  },

  {
    key: "customer-care",
    label: "Customer Care",
    icon: FaClipboardUser,
    menus: [
      { label: "Customer Detail", path: "/admin/customer-care-detail", icon: GoChecklist },
      { label: "Verify Technician ", path: "/admin/customer-technician-verify", icon: GoChecklist },

    ],
  },

  {
    key: "team-leader",
    label: "Team Leader",
    icon: RiAdminLine,
    menus: [
      { label: "All Call List ", path: "/admin/call-verify", icon: PiPhoneCallBold },
    ],
  },
  {
    key: "telecaller",
    label: "Telecaller",
    icon: LuHeadset,
    menus: [
      { label: "Telecaller Call List ", path: "/admin/telecaller-call", icon: PiPhoneCallBold },
    ],
  },
  {
    key: "AMC",
    label: "AMC",
    icon: RiRedPacketFill,
    menus: [
      { label: "AMC Quotation", path: "/admin/amc-quotation", icon: RiBillLine },
      { label: "AMC", path: "/admin/amc", icon: HiTemplate },
      { label: "AMC Report", path: "/admin/amc-report", icon: TbReportSearch },
      { label: " Document", path: "/admin/amc-document", icon: GiBlackBook },
    ],
  },
  {
    key: "warranty",
    label: "Warrantty",
    icon: IoTimerOutline,
    menus: [
      { label: "Warranty", path: "/addmin/warranty", icon: CiViewTimeline },
      { label: "Warranty Report ", path: "/admin/warranty-report", icon: TbReportSearch },

    ],
  },
  {
    key: "production",
    label: "Production",
    icon: MdOutlineProductionQuantityLimits,
    menus: [
      { label: "Batch", path: '/admin/batch-master', icon: CiViewTimeline },
      { label: "BOM", path: '/admin/bom-master', icon: SiMaterialdesignicons },
      { label: "Production", path: '/admin/material-production', icon: TbBrandProducthunt },
    ],
  },
  {
    key: "costing",
    label: "Costing",
    icon: RiMoneyRupeeCircleLine,
    menus: [
      { label: "Cost Center ", path: "/admin/cost-center", icon: FaCentercode },
      // { label: "Cost Category ", path: "/admin/cost-category" ,icon:HiMiniBuildingOffice2}, 
      { label: "Cost Center Link ", path: "/admin/cost-center-link", icon: GrLink },
    ],
  },
  {
    key: "userRights",
    label: "User Rights",
    icon: FaUserLock,
    menus: [
      { label: "User Rights", path: "/admin/user-right" },
    ],
  },
  {
    key: "message",
    label: "Message Section",
    icon: RiMessage2Line,
    menus: [
      { label: "Message Master", path: "/admin/message-master", icon: LuMessageSquareText },
      { label: "Service Reminder", path: "/admin/message-reminder", icon: TbMessage2Star },
    ],
  },

  {
    key: "banner",
    label: "Banner Section",
    icon: FaRegImage,
    menus: [
      { label: "Add Banner", path: "/admin/banner" },
      { label: "Customer Enquiry", path: "/admin/customer-enquiry", icon: TfiHeadphoneAlt },
    ],
  },

  //  {
  //   key: "fixed_assets",
  //   label: "Fixed Assets",
  //   icon:FaMoneyCheckDollar,
  //   menus: [
  //          { label: "Depreciation Method", path: "/admin/depreciation-method" ,icon:MdInsertPageBreak},
  //           { label: "Assets", path: "/admin/assets" ,icon:MdInsertPageBreak},      
  //  ],
  // },

   {
    key: "appraisal",
    label: "Appraisal",
    icon:GoPerson ,
    menus: [
           { label: "Parameter", path: "/admin/appraisal-parameter" ,icon:BsPersonBoundingBox},
          { label: "Rating", path: "/admin/appraisal-rating" ,icon:FaStarHalfStroke},
           { label: "Type", path: "/admin/appraisal-type" ,icon:DiGitBranch},
            { label: "Appraisal", path: "/admin/appraisal" ,icon:PiChalkboardTeacherFill},
   ],
  },
    {
    key: "emi",
    label: "EMI",
    icon: RiPagesFill ,
    menus: [
      { label: "EMI", path: "/admin/party-emi", icon:HiDocumentCurrencyRupee },
     
    ],
  },

  {
    key: "report",
    label: "Report",
    icon: TbReportAnalytics,
    menus: [
      { label: "PF Report", path: "/admin/pf-report", icon: TbReportMoney },
      { label: "Costing Report", path: "/admin/costing-report", icon: TbReportMedical },
    ],
  },
];

